/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invitation_AcceptedInputs */

const th_invitation_accepted = /** @type {(inputs: Invitation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตอบรับแล้ว`)
};

const en_invitation_accepted = /** @type {(inputs: Invitation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accepted`)
};

const ja_invitation_accepted = /** @type {(inputs: Invitation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`承認済み`)
};

const zh_invitation_accepted = /** @type {(inputs: Invitation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已接受`)
};

const es_invitation_accepted = /** @type {(inputs: Invitation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceptada`)
};

const pt_invitation_accepted = /** @type {(inputs: Invitation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceito`)
};

const id_invitation_accepted = /** @type {(inputs: Invitation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diterima`)
};

const fr_invitation_accepted = /** @type {(inputs: Invitation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceptée`)
};

const tl_invitation_accepted = /** @type {(inputs: Invitation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tinanggap`)
};

const vi_invitation_accepted = /** @type {(inputs: Invitation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã nhận`)
};

const ko_invitation_accepted = /** @type {(inputs: Invitation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수락함`)
};

const de_invitation_accepted = /** @type {(inputs: Invitation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angenommen`)
};

const ru_invitation_accepted = /** @type {(inputs: Invitation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Принято`)
};

const tr_invitation_accepted = /** @type {(inputs: Invitation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kabul edildi`)
};

const it_invitation_accepted = /** @type {(inputs: Invitation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accettato`)
};

const pl_invitation_accepted = /** @type {(inputs: Invitation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przyjęto`)
};

const uk_invitation_accepted = /** @type {(inputs: Invitation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прийнято`)
};

const hi_invitation_accepted = /** @type {(inputs: Invitation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वीकृत`)
};

const ar_invitation_accepted = /** @type {(inputs: Invitation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مقبولة`)
};

const ms_invitation_accepted = /** @type {(inputs: Invitation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diterima`)
};

const bn_invitation_accepted = /** @type {(inputs: Invitation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`গৃহীত`)
};

const zh_tw2_invitation_accepted = /** @type {(inputs: Invitation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已接受`)
};

const zh_hk2_invitation_accepted = /** @type {(inputs: Invitation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已接受`)
};

const ur_invitation_accepted = /** @type {(inputs: Invitation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قبول شدہ`)
};

const fa_invitation_accepted = /** @type {(inputs: Invitation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پذیرفته‌شده`)
};

const sw_invitation_accepted = /** @type {(inputs: Invitation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imekubaliwa`)
};

const nl_invitation_accepted = /** @type {(inputs: Invitation_AcceptedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aangenomen`)
};

/**
* | output |
* | --- |
* | "Accepted" |
*
* @param {Invitation_AcceptedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const invitation_accepted = /** @type {((inputs?: Invitation_AcceptedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invitation_AcceptedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_invitation_accepted(inputs)
	if (locale === "ja") return ja_invitation_accepted(inputs)
	if (locale === "zh") return zh_invitation_accepted(inputs)
	if (locale === "es") return es_invitation_accepted(inputs)
	if (locale === "pt") return pt_invitation_accepted(inputs)
	if (locale === "id") return id_invitation_accepted(inputs)
	if (locale === "fr") return fr_invitation_accepted(inputs)
	if (locale === "tl") return tl_invitation_accepted(inputs)
	if (locale === "vi") return vi_invitation_accepted(inputs)
	if (locale === "ko") return ko_invitation_accepted(inputs)
	if (locale === "de") return de_invitation_accepted(inputs)
	if (locale === "ru") return ru_invitation_accepted(inputs)
	if (locale === "tr") return tr_invitation_accepted(inputs)
	if (locale === "it") return it_invitation_accepted(inputs)
	if (locale === "pl") return pl_invitation_accepted(inputs)
	if (locale === "uk") return uk_invitation_accepted(inputs)
	if (locale === "hi") return hi_invitation_accepted(inputs)
	if (locale === "ar") return ar_invitation_accepted(inputs)
	if (locale === "ms") return ms_invitation_accepted(inputs)
	if (locale === "bn") return bn_invitation_accepted(inputs)
	if (locale === "zh-TW") return zh_tw2_invitation_accepted(inputs)
	if (locale === "zh-HK") return zh_hk2_invitation_accepted(inputs)
	if (locale === "ur") return ur_invitation_accepted(inputs)
	if (locale === "fa") return fa_invitation_accepted(inputs)
	if (locale === "sw") return sw_invitation_accepted(inputs)
	if (locale === "nl") return nl_invitation_accepted(inputs)
	return en_invitation_accepted(inputs)
});